import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import {
  CLINIC_ONE_API_BASE_URL,
  CLINIC_ONE_API_VER,
} from "@kells/clinic-one/environments";
import {
  PatientFeatues,
  CheckoutLinkRequest,
  CheckoutLinkResponse,
  PATIENT_FEATURES_BY_PLAN,
  Product,
  ProductResponse,
  SubscriptionPlan,
  FreeScans,
  FreeScansResponse,
} from "@kells/interfaces/patient";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class MembershipService {
  productsBaseUrl = `${this.baseUrl}/${this.apiVersion}/products`;

  constructor(
    @Inject(CLINIC_ONE_API_BASE_URL) private baseUrl: string,
    @Inject(CLINIC_ONE_API_VER) private apiVersion: string,
    private http: HttpClient
  ) {}

  getProducts(): Observable<Product[]> {
    return this.http.get<ProductResponse>(`${this.productsBaseUrl}`).pipe(
      map((res) =>
        res.data.products.map((product) => ({
          ...product,
          price_amount: product.price_amount / 100,
        }))
      )
    );
  }

  getProductCheckoutLink(body: CheckoutLinkRequest): Observable<string> {
    return this.http
      .post<CheckoutLinkResponse>(`${this.productsBaseUrl}/checkout`, body)
      .pipe(map((res) => res.data.url));
  }

  getProductsFreeScans(): Observable<FreeScans> {
    return this.http
      .get<FreeScansResponse>(`${this.productsBaseUrl}/free-scans`)
      .pipe(map((res) => res.data));
  }

  static isFeatureAvailable(
    feature: PatientFeatues,
    plan: SubscriptionPlan
  ): boolean {
    const featurePlans = PATIENT_FEATURES_BY_PLAN[feature];

    return featurePlans.includes(plan);
  }
}
